/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable spaced-comment */
import React, { useEffect, useState } from 'react';
import { Card, Result, Descriptions, Space } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import env from '../../Utils/Constants/env';
import { formatDateAndTime } from '../../Utils/date-utils';

const PaymentFailed = () => {
	const params = new URLSearchParams(window.location.search);
	const token = params.get('token');

	const [transactionData, setTransactionData] = useState(null);

	useEffect(() => {
		const fetchTransactionData = async () => {
			try {
				const uri = `${env.baseUri}payment/transaction/${token}`;
				const response = await fetch(uri, {
					method: 'GET',
				});

				const data = await response.json();
				console.info('Transaction data:', data);
				setTransactionData(data);
			} catch (error) {
				console.info('Error fetching transaction data:', error);
			}
		};

		if (token) {
			fetchTransactionData();
		}
	}, [token]);
	return (
		<div
			style={{
				minHeight: '100vh',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				backgroundColor: '#f0f2f5',
				padding: '20px',
			}}>
			<Card style={{ maxWidth: 500, width: '100%' }}>
				<Result
					status='error'
					title='Payment Failed'
					subTitle="We couldn't process your payment. Please try again or use a different payment method."
					icon={<CloseCircleOutlined />}
					extra={[
						<Space direction='vertical' size='large' style={{ width: '100%' }}>
							<Descriptions
								title='Transaction Details'
								bordered
								column={1}
								size='small'>
								<Descriptions.Item label='Transaction ID'>
									{transactionData?.transactionId}
								</Descriptions.Item>
								<Descriptions.Item label='Amount'>
									€{parseFloat(transactionData?.amount) / 100}
								</Descriptions.Item>
								<Descriptions.Item label='Date'>
									{formatDateAndTime(transactionData?.date)}
								</Descriptions.Item>
								<Descriptions.Item label='Payment Method'>
									Credit Card
								</Descriptions.Item>
							</Descriptions>
						</Space>,
					]}
				/>
			</Card>
		</div>
	);
};

export default PaymentFailed;
